module.exports = __webpack_public_path__ + "static/media/20210409_194825_756_IMG_0083.7f430e66.jpg";